import styled from 'styled-components';

const BindRecordStyled = styled.div`
  height: 100%;
`;

export default BindRecordStyled;
